import { render, staticRenderFns } from "./pluginItem.vue?vue&type=template&id=05cdc214&scoped=true&"
import script from "./pluginItem.vue?vue&type=script&lang=js&"
export * from "./pluginItem.vue?vue&type=script&lang=js&"
import style0 from "./pluginItem.vue?vue&type=style&index=0&id=05cdc214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdc214",
  null
  
)

export default component.exports